import { addValidationRule } from '@jumpcloud/ui-components';
import { email as emailRule, required } from 'vee-validate/dist/rules.umd';
import { extend } from 'vee-validate';
import axios from 'axios';

const customRules = [
  {
    rule: 'noPersonalEmail',
    ruleConfig: {
      validate: async (value) => {
        const endpoint = `${window.location.origin}/api/v2/validatedomain?domain=${value}`;
        try {
          const response = await axios.get(endpoint);
          return response.data.message === 'Continue';
        } catch (error) {
          // eslint-disable-next-line
          console.error(error);

          const fallbackPersonalEmailDomains = [
            'gmail.com',
            'yahoo.com',
            'hotmail.com',
            'comcast.net',
            'qq.com',
            'outlook.com',
            'icloud.com',
            'msn.com',
            'live.com',
            'tutanota.com',
            'posteo.de',
            'mailbox.com',
            'fastmail.com',
            'yandex.com',
            'gmx.com',
            'info.com',
            'mailinator.com',
            'protonmail.com',
            'proton.me',
            'pm.me',
            'protonmail.ch',
            'sharklasers.com',
          ];

          return fallbackPersonalEmailDomains.every((domain) => !value.endsWith(`@${domain}`));
        }
      },
      message: 'Please provide a valid company email',
    },
  },
  {
    rule: 'email',
    ruleConfig: {
      ...emailRule,
      message: 'Please provide a valid company email',
    },
  },
  {
    rule: 'required',
    ruleConfig: {
      ...required,
    },
  },
];

customRules.forEach((customRule) => {
  extend(customRule.rule, customRule.ruleConfig);
  addValidationRule(customRule.rule, customRule.ruleConfig);
});
